import { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import LoginScreen from './LoginScreen';
import AshGroCRM from './ashgro-crm';

export default function App() {
  const [session, setSession] = useState(null);
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    if (!supabase) {
      setAuthReady(true);
      return;
    }
    supabase.auth.getSession().then(({ data: { session: s } }) => {
      setSession(s);
      if (s?.user?.id) window._supabaseAuthId = s.user.id;
      setAuthReady(true);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, s) => {
      setSession(s);
      if (s?.user?.id) window._supabaseAuthId = s.user.id;
    });
    return () => subscription?.unsubscribe();
  }, []);

  const handleLogout = async () => {
    if (supabase) await supabase.auth.signOut();
    setSession(null);
  };

  if (!authReady) {
    return null;
  }

  if (!session) {
    return <LoginScreen />;
  }

  return <AshGroCRM onLogout={handleLogout} userId={session?.user?.id} userEmail={session?.user?.email} />;
}
